import { fork, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import {
  LogControllerDtoGearMiningLogListRequest,
  LogControllerDtoNftDisassembleLogListRequest,
  LogControllerDtoNftDisassembleLogListResponse,
  PerplayLogApi
} from '../../models/src';
import { NFT_DISASSEMBLE_LOG_LIST_REQUEST } from '../../constants/log/nftDisassembleLogConstants';
import { getErrorMessage } from '../../../utils/serverErrorCheck';

const api = new PerplayLogApi(config.API_CLIENT);

function* nftDisassembleLogListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new LogControllerDtoNftDisassembleLogListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.account = payload.account;
    requestData.nftUid = payload.nftUid;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayLogNftDisassembleLogListPost({ logControllerDtoNftDisassembleLogListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, LogControllerDtoNftDisassembleLogListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* nftDisassembleLogRootSaga() {
  yield all([
    takeEvery(NFT_DISASSEMBLE_LOG_LIST_REQUEST, nftDisassembleLogListRequestSaga),
  ])
}

const nftDisassembleLogSaga = [
  fork(nftDisassembleLogRootSaga),
];

export default nftDisassembleLogSaga;
